import {
  SubdimensionVisitMetrics,
  VisitMetrics,
} from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { PerformanceMetric } from '@features/executive-report/dimensions/content';
import { formatWithSign } from '@features/executive-report/utils/format-with-sign';
import { formatters } from '@utils/formattersV2';

export const overallPerformanceMetrics = (
  visitMetrics: VisitMetrics
): PerformanceMetric[] => [
  {
    label: 'Incremental Visits and Lift',
    value: formatters.visits(visitMetrics.incrementalVisits),
    lift: formatWithSign(visitMetrics.incrementalLift, value =>
      formatters.lift(value, { decimals: 1 })
    ),
  },
  {
    label: 'Total Projected Visits',
    value: formatters.visits(visitMetrics.projectedVisits, { full: true }),
  },
  {
    label: 'Unique Users',
    value: formatters.users(visitMetrics.uniqueUsers, { full: true }),
  },
  {
    label: 'Total Impressions',
    value: formatters.impressions(visitMetrics.impressions, { full: true }),
  },
];

export const dimensionMetrics = (
  visitMetrics: SubdimensionVisitMetrics
): PerformanceMetric[] => [
  {
    label: 'Visit Lift',
    value: formatWithSign(visitMetrics.incrementalLift, value =>
      formatters.lift(value, { decimals: 1 })
    ),
  },
  {
    label: 'Incremental Visits',
    value: formatters.visits(visitMetrics.incrementalVisits, { full: true }),
  },
  {
    label: 'Impressions',
    value: formatters.impressions(visitMetrics.impressions, { full: true }),
  },
];
